import { useEffect, useRef } from 'react'
import { CartElementType, useCartLayoutContext } from 'src/lib/contexts/CartLayoutContext'
import { classNames } from 'src/lib/utils/helpers'

export const CartFeatureHOC = ({
  element,
  fitContent = false,
  children,
  hideBorder = false
}: {
  element: CartElementType
  fitContent?: boolean
  children: React.ReactNode
  hideBorder?: boolean
}) => {
  const {
    getters: { selectedElement },
    actions: { setSelectedElement }
  } = useCartLayoutContext()
  const elementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (selectedElement === element && elementRef.current) {
      elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }, [selectedElement, element])

  const isSelected = selectedElement === element
  const getBorderStyle = () => {
    if (isSelected) return 'rounded'
    if (selectedElement === null) return ''
    return 'opacity-40'
  }

  return (
    <div
      ref={elementRef}
      className={classNames('relative cursor-pointer', fitContent ? 'w-fit' : 'w-full', getBorderStyle())}
      onClick={e => {
        setSelectedElement(element, { fromPreview: true })
        e.stopPropagation()
      }}
    >
      {children}
    </div>
  )
}
